import type { CartItemOutputDto } from "@sticker-giant/sg-frontend-common";
import { ItemProductType, SkuCodes, ThumbnailGenerator } from "@sticker-giant/sg-frontend-common";

export function isFinishedGood(item: CartItemOutputDto): boolean {
  return item.sku.product === ItemProductType.FIN;
}

export function isKissCut(item: CartItemOutputDto): boolean {
  return (
    item.sku.marketingName === SkuCodes.MarketingName.KissCutStickers ||
    item.sku.marketingName === SkuCodes.MarketingName.KissCutStickerRetired ||
    item.sku.marketingName === SkuCodes.MarketingName.KissCutHolographicStickers
  );
}

export function getImageUrl(item: CartItemOutputDto): string {
  if (item.noArt) return "/images/no-art.svg";
  if (!item.fileUrl) return "/images/broken-image.svg";
  return ThumbnailGenerator.getUrl(item.fileBucket, item.fileUrl, item.artworkPage);
}

const PLACEHOLDER_PATHS = ["/images/no-art.svg", "/images/broken-image.svg"];

export function hasArtworkPreview(item: CartItemOutputDto): boolean {
  const url = getImageUrl(item);
  return !!url && !PLACEHOLDER_PATHS.includes(url);
}
